export default __webpack_public_path__ + "static/media/puppyFemalePurple.a67bc8f7.jpg";